import React from 'react';
import { FormField as FormFieldType, FormTheme } from '../types';
import { TextInput } from './fields/TextInput';
import { EmailInput } from './fields/EmailInput';
import { Textarea } from './fields/Textarea';
import { Select } from './fields/Select';
import { FileUpload } from './fields/FileUpload';
import { NumberInput } from './fields/NumberInput';
import { PhoneInput } from './fields/PhoneInput';
import { Checkbox } from './fields/Checkbox';

interface FormFieldProps {
  field: FormFieldType;
  value: any;
  onChange: (value: any) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: string;
  theme: FormTheme;
  disabled?: boolean;
}

export const FormField: React.FC<FormFieldProps> = ({
  field,
  value,
  onChange,
  onFocus,
  onBlur,
  error,
  theme,
  disabled,
}) => {
  const commonProps = {
    id: field.fieldId,
    label: field.label,
    required: field.required,
    value: value ?? '',
    onChange,
    onFocus,
    onBlur,
    error,
    disabled,
    theme,
    config: field.config || {},
  };

  switch (field.componentType) {
    case 'text_input':
      return <TextInput {...commonProps} />;

    case 'email_input':
      return <EmailInput {...commonProps} />;

    case 'phone_input':
      return <PhoneInput {...commonProps} />;

    case 'number_input':
      return <NumberInput {...commonProps} />;

    case 'textarea':
      return <Textarea {...commonProps} />;

    case 'select':
      return <Select {...commonProps} />;

    case 'file_upload':
      return <FileUpload {...commonProps} value={value ?? null} />;

    case 'checkbox':
      return <Checkbox {...commonProps} value={!!value} />;

    default:
      return <TextInput {...commonProps} />;
  }
};
